import { render, staticRenderFns } from "./Ver.vue?vue&type=template&id=281b8b96&scoped=true&lang=pug&"
import script from "./Ver.vue?vue&type=script&lang=js&"
export * from "./Ver.vue?vue&type=script&lang=js&"
import style0 from "./Ver.vue?vue&type=style&index=0&id=281b8b96&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281b8b96",
  null
  
)

export default component.exports